<template>
    <div class="main-body">
        <div class="header">申请改造</div>
        <div class="out">

            <div class="search2">

              <el-button type="primary" size="mini" @click.native="toggleModalAdd">添加</el-button>

            </div>

            <el-table class="table" size="mini" :data="tableData" v-loading="loading"
                      :height="th" border>

              <el-table-column type="expand" v-if="tableData.length">
                <template slot-scope="props">

                  <el-table size="mini" :data="props.row.listElderlyBedGoodsRelDTO" border>

                    <el-table-column prop="bedGoodsName" label="改造项目"></el-table-column>

                    <el-table-column width="200" label="施工前图片">
                      <template slot-scope="scope">
                        <div v-if="scope.row.elderlyBedGoodsRelRecordDTOStart != null ">
                          <el-popover placement="right" trigger="click" v-for="(item,index) in scope.row.elderlyBedGoodsRelRecordDTOStart.listElderlyBedGoodsRelRecordImg" :key="index">
                            <img :src="imgUrl+item.imgPath+'_watermark.jpg'" style="width: 500px"/>
                            <img slot="reference" :src="imgUrl+item.imgPath+'_watermark.jpg'" style="width:60px">
                          </el-popover>

                          <div>{{timefilter('','',scope.row.elderlyBedGoodsRelRecordDTOStart.createTime)}}</div>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column width="200" label="施工后图片">
                      <template slot-scope="scope">
                        <div v-if="scope.row.elderlyBedGoodsRelRecordDTOEnd != null ">
                          <el-popover placement="right" trigger="click" v-for="(item,index) in scope.row.elderlyBedGoodsRelRecordDTOEnd.listElderlyBedGoodsRelRecordImg" :key="index">
                            <img :src="imgUrl+item.imgPath+'_watermark.jpg'" style="width: 500px"/>
                            <img slot="reference" :src="imgUrl+item.imgPath+'_watermark.jpg'" style="width:60px">
                          </el-popover>

                          <div>{{timefilter('','',scope.row.elderlyBedGoodsRelRecordDTOEnd.createTime)}}</div>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column prop="checkStatus" label="验收状态">
                      <template slot-scope="scope">
                        <span v-if="scope.row.checkStatus==0">未验收</span>
                        <span v-if="scope.row.checkStatus==1">验收通过</span>
                        <span v-if="scope.row.checkStatus==2">验收不通过</span>
                      </template>
                    </el-table-column>


                  </el-table>


                </template>
              </el-table-column>



              <el-table-column label="老人姓名" prop="elderlyName" width="100"></el-table-column>

              <el-table-column prop="createTime" :formatter="timefilter" label="申请时间"></el-table-column>



              <!--              <el-table-column prop="speed" label="改造进度">-->
<!--                <template slot-scope="scope">-->
<!--                  <span v-if="scope.row.speed==1">评估中</span>-->
<!--                  <span v-if="scope.row.speed==2">施工中</span>-->
<!--                  <span v-if="scope.row.speed==3">验收中</span>-->
<!--                  <span v-if="scope.row.speed==4">已完工</span>-->
<!--                </template>-->
<!--              </el-table-column>-->


              <el-table-column prop="speed" label="改造进度" width="200">
                <template slot-scope="scope">
                  <el-steps :space="200" :active="scope.row.speed-1" finish-status="success">
                    <el-step title="评估"></el-step>
                    <el-step title="施工"></el-step>
                    <el-step title="验收"></el-step>
                    <el-step title="完工"></el-step>
                  </el-steps>
                </template>
              </el-table-column>






<!--              <el-table-column fixed="right" label="操作" width="150">-->
<!--                <template slot-scope="scope">-->
<!--                  <el-button type="text" size="mini"-->
<!--                             @click="handlePrint(scope.$index, scope.row)">查看进度</el-button>-->
<!--                </template>-->
<!--              </el-table-column>-->

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>


      <Add ref="myAdd" v-show="showModalAdd"
             v-on:closeAdd="closeAdd"
             v-on:getList="getList"></Add>


    </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import Add from "./Add";


    export default {
        name: "Role",
        data(){
            return{
              loading:false,

              showModalAdd:false,
              voucherDialog:false,

              showModalGetElderly:false,

              elderlyCode:'',
              elderlyName:'',


              tableData:[],
              totalItems: 0,
              pageSize:20,
              currentPage:1,

              th:0,

              imgUrl: this.$imgUrl,


            }
        },
        components:{
            Add,
        },

        created(){

            this.getList();

            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{


          timefilter(row, column, cellValue) {
            return timefilters(cellValue);
          },

          toggleModalAdd:function(){
              this.showModalAdd = !this.showModalAdd;
              this.$refs.myAdd.init();
          },
          closeAdd:function(){
              this.showModalAdd = !this.showModalAdd;
          },

          current_change:function(currentPage){
              this.currentPage = currentPage;
              this.getList();
          },
          getList(isSearch){
              if(isSearch)this.currentPage=1

              this.loading = true;

              this.$axios({
                  method: 'post',
                  url: this.$shopUrl+"AssessElderlyRel/InsPage",
                  data: {
                      timeStr:timeStr,
                      sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                      staffCode: getStaffCode(),
                      pageIndex:this.currentPage,
                      pageSize:this.pageSize,
                    applyStatus:1,
                  }
              }).then( (response)=> {
                  this.loading = false;
                  if(response.data.error == 0){
                    this.tableData = response.data.data.pageInfo.list;
                    this.totalItems = response.data.data.pageInfo.total;
                  }else if(response.data.error == 1){
                    this.$message({type: 'info', message: response.data.message});
                  }
              }).catch(function (error) {
                  console.log(error);
              });
          },


        }
    }
</script>
<style lang="scss" scoped>

</style>
